module.exports = __webpack_public_path__ + "static/img/sh_shz.44ae951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sh_shz.png
// module id = mO+S
// module chunks = 167